<template>
  <div class="main-content">
    <div class="card">
      <div class="card-body">
        <pulse-loader :loading="loading" :color="$constants.LOADING_COLOR" class="text-center"/>
        <div class="flex justify-content-between">
          <div>
            <p>Всего заявок: <strong>{{ paginator?.total ?? 0 }}</strong></p>
            <div class="input-group">
              <input type="text" placeholder="ФИО" v-model="search.name" class="form-control">
              <div class="input-group-prepend input-group-append">
                <button @click="() => getRecords(1)" class="btn btn-outline-info">поиск</button>
              </div>
            </div>
          </div>
          <div class="flex">
            <div class="mr-2" v-if="adminMode">
              <input @change="getRecords" v-model="perPage" type="number"
                     placeholder="Кол. на странице"
                     class="form-control mr-2">
              <div class="form-group">
                <label><input type="checkbox" @change="getRecords" v-model="sorting.weight"> добавление веса
                  первыми</label>
              </div>
            </div>
            <div>
              <div class="flex">
                <LoadingButton
                  title="Распечатать стикеры"
                  type="button"
                  :loading="btnLoading"
                  :color="$constants.PRIMARY_COLOR"
                  :onClick="() => printStickers()"
                  className="btn btn-sm btn-outline-info mr-2"
                />

                <LoadingButton
                  title="Создать файл для почты"
                  type="button"
                  :loading="btnLoading"
                  :color="$constants.SUCCESS_COLOR"
                  :onClick="() => generateImport()"
                  className="btn btn-sm btn-outline-success"
                />
              </div>
            </div>
          </div>
        </div>
        <template v-if="!loading && records">
          <SimpleOrderList
            ref="ordersList"
            :orders="records"
            :drugsImages="drugsImages"
            :paginator="paginator"
          />
          <div class="text-right">
            <paginate v-if="paginator"
                      v-model="paginator.current_page"
                      :page-count="paginator.last_page"
                      :page-range="5"
                      :margin-pages="4"
                      :click-handler="getRecords"
                      :prev-text="'&laquo'"
                      :next-text="'&raquo'"
                      :container-class="'pagination'"
                      :prev-class="'page-item'"
                      :prev-link-class="'page-link'"
                      :page-class="'page-item'"
                      :page-link-class="'page-link'"
                      :next-class="'page-item'"
                      :next-link-class="'page-link'"
                      :active-class="'active green_btn'">
            </paginate>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>

import api from "@/api";
import SimpleOrderList from "@/components/orders/SimpleOrderList.vue";
import LoadingButton from "@/components/buttons/LoadingButton.vue";
import Paginate from 'vuejs-paginate'

export default {
  components: {
    LoadingButton,
    SimpleOrderList,
    Paginate,
  },
  data() {
    return {
      search: {
        name: ''
      },
      adminMode: false,
      sorting: {weight: false},
      loading: false,
      btnLoading: false,
      records: null,
      perPage: '',
      drugsImages: {},
      paginator: null,
    }
  },
  created() {
    if (this.$currentRole === 'admin' || this.$currentUserRoles.includes('postManager')) {
      this.adminMode = true;
    }
    this.getRecords()
  },
  methods: {
    async generateImport() {
      const selectedOrders = Object.keys(this.$refs.ordersList.selectedOrders).reduce((acc, id) => {
        if (this.$refs.ordersList.selectedOrders[id]) acc.push(id);
        return acc;
      }, [])
      if (!selectedOrders.length) {
        toastr['warning']('Нет выбранных заявок');
        return;
      }
      this.btnLoading = true;
      const {data} = await api.post('/excel/generatePostImport', {
        selectedOrders
      })
      if (data.success) {
        window.open(data.link, '_blank').focus();
      } else {
        toastr['warning'](data.message ?? 'Ошибка сервера');
      }
      this.btnLoading = false;
    },
    async printStickers() {
      const orders = Object.keys(this.$refs.ordersList.selectedOrders).reduce((acc, id) => {
        if (this.$refs.ordersList.selectedOrders[id]) acc.push(id);
        return acc;
      }, [])
      if (!orders.length) {
        toastr['warning']('заявки не выбраны');
        return;
      }
      this.btnLoading = true;
      const {data} = await api.post('/excel/generatePostStickers', {
        type: 'preSend',
        orders: orders
      })
      if (data.success) {
        window.open(data.link, '_blank').focus();
      } else {
        toastr['warning'](data.message || 'ошибка сервера', 'Неуспешно')
      }
      this.btnLoading = false;
    },
    async getRecords(page = 1) {
      this.loading = true;
      let {data: r_data} = await api.index('/runners/orders/forSend?page=' + page + '&pp=' + this.perPage + '&sortW=' + this.sorting.weight + '&name=' + this.search.name);
      if (r_data.success) {
        const {data, ...pagination} = r_data.records;
        this.paginator = pagination;
        this.drugsImages = r_data.drugsImages;
        this.records = Object.values(data);
      }
      this.loading = false;
    }
  }
}

</script>
